import { useModalActions } from '@mm/state/modules/modalsState/actions';
import IphoneX from 'assets/iphone_x.svg';
import React, { ReactNode, useState } from 'react';
import Popover from 'react-tiny-popover';
import './MobileDownloadPopover.scss';

type Props = {
  children: string | ReactNode | Element[];
};
export const MobileDownloadPopover = ({ children }: Props) => {
  const [isDownloadAppOpen, setIsDownloadAppOpen] = useState(false);
  const modalActions = useModalActions();

  return (
    <Popover
      isOpen={isDownloadAppOpen}
      content={
        <div
          className="mobile-download--popover"
          onMouseLeave={() => setIsDownloadAppOpen(false)}
        >
          <div className="mobile-download--popover-arrow" />
          <div className="mobile-download--popover-content">
            <img
              alt="IPhone X Frame"
              className="mobile-download--popover-image"
              src={IphoneX}
            />
            <div
              className="mobile-download--popover-text"
              onClick={modalActions.openMobileDownloadModal}
            >
              <div>Download the</div>
              <div>mobile app!</div>
            </div>
          </div>
        </div>
      }
    >
      <span
        className="mobile-download--help"
        onMouseEnter={() => setIsDownloadAppOpen(true)}
      >
        {children}
      </span>
    </Popover>
  );
};
